import { useCurrentStateAndParams } from "@uirouter/react";

import { SubsectionItem, EPrimaryItemType } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { sidebarTrackingDispatcher } from "app/components/sidebar3/secondary-side-bar/components/DigitalSuiteNavBarUtils";
import { translate } from "app/filters/i18nFilter";
import { EPrimarySideBar3StateType } from "app/reducers/_reducers/PrimarySidebar3Reducer";
import { GrowthbookService, TestsNames } from "app/services/trackingServices/GrowthBookService";
import { TestValues } from "app/services/trackingServices/types";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { allTrackers } from "app/services/track/track";

import { DEFAULT_TRACKING_PARAMS, POSITION_FOR_TRACKING } from "../activation/constants";

type AfterTrialDigitalSuiteHomeItemProps = { isOpen: boolean };

const DIGITAL_SUITE_HOME_STATE = EPrimarySideBar3StateType.Home;

export const AfterTrialDigitalSuiteHomeItem = ({ isOpen }: AfterTrialDigitalSuiteHomeItemProps) => {
    const { state } = useCurrentStateAndParams();
    const isSelected = state.name === DIGITAL_SUITE_HOME_STATE;

    const handleClick = () => {
        const variant = GrowthbookService.growthbookInstance.getFeatureValue(
            TestsNames.AFTER_TRIAL_DS_HOME_SIDEBAR,
            TestValues.CONTROL,
        );
        sidebarTrackingDispatcher({
            ...DEFAULT_TRACKING_PARAMS,
            report_domain: DIGITAL_SUITE_HOME_STATE,
            analytics_domain: DIGITAL_SUITE_HOME_STATE,
            position_order: POSITION_FOR_TRACKING,
            is_locked: false,
        });
        allTrackers.dispatchTrackEvent(
            "sidebar.after_trial_ds_home.click",
            "click",
            "sidebar.after_trial_ds_home.click",
        );
        return proNavigator.go(DIGITAL_SUITE_HOME_STATE);
    };

    return (
        <Flex
            data-automation="digitalsuite-sidebar-after-trial-home"
            width="100%"
        >
            <SubsectionItem
                isSelected={isSelected}
                key="after-trial-digitalsuite-home-menu-item"
                itemText={translate("digitalsuite.sidebar.home.title")}
                icon="homepage"
                itemType={EPrimaryItemType.StandalonePrimary}
                isCollapsed={!isOpen}
                onItemClick={handleClick}
            />
        </Flex>
    );
};
